/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { withInstall } from '../utils/withInstall.js';
import ConfigProvider$1 from './config-provider.js';
import './type.js';
import '@babel/runtime/helpers/defineProperty';
import 'vue';
import 'lodash/capitalize';
import 'lodash/cloneDeep';
import './context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';

var ConfigProvider = withInstall(ConfigProvider$1);

export { ConfigProvider, ConfigProvider as default };
//# sourceMappingURL=index.js.map
